import React from 'react';
import './header-style.css';

export default (props) => {
    return (
<header className="Header-header">
    {/* <img src={props.logo} className="Header-logo" alt="logo" /> */}
    <span className="Header-title">{props.title}</span>
</header>
    );
}



// WEBPACK FOOTER //
// ./src/components/header.js